import { useEditor } from '@craftjs/core';
import { SliderField } from '../SliderField/SliderField';
import type { FormProps } from '@builder4/shared/components/Form';
import { useInspectorNode } from '@/hooks/useInspectorNode';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { FORM_NODE_NAME } from '@/utils/constants';

const NodeFieldTextSize = () => {
  const { actions } = useEditor();
  const { id, props: nodeProps, node } = useInspectorNode<Partial<FormProps>>();

  const { getBPProp, setBPProp } = useBreakpointAwareProp(node?.data.displayName || FORM_NODE_NAME);

  // Read props using breakpoint-aware getter
  const fieldInputFontSize = getBPProp(nodeProps, 'fieldInputFontSize');

  const parseFontSize = (size?: string): number => {
    if (!size) return 14;
    return parseInt(size.replace('px', ''), 10) || 14;
  };

  const handleChange = (value: number) => {
    const newSize = `${value}px`;
    actions.history.ignore().setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldInputFontSize', newSize, FORM_NODE_NAME);
    });
  };

  const handleChangeComplete = (value: number, initialValue: number) => {
    actions.history.ignore().setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldInputFontSize', `${initialValue}px`, FORM_NODE_NAME);
    });
    actions.setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldInputFontSize', `${value}px`, FORM_NODE_NAME);
    });
  };

  return (
    <SliderField
      label="Size"
      value={parseFontSize(fieldInputFontSize)}
      onChange={handleChange}
      onChangeComplete={handleChangeComplete}
      min={8}
      max={48}
    />
  );
};

export default NodeFieldTextSize;
